<!-- Registaration -->
<div class="registaration">
  <div class="r-header">
    <img src="assets/images/logo-dark.svg" alt="">
  </div>
  <div class="register-sidebar">
    <video class="bg-video" muted loop autoplay playsinline>
      <source src="../../../../assets/images/luqta-video.mp4" type="video/mp4">
      Your browser does not support the video tag.
    </video>

    <img src="assets/images/logo2.svg" class="logo" alt="">
    <h2>
      {{ 'signup.intro' | translate }}
    </h2>
  </div>
  <div class="form-body">
    <div class="cant-have-account">
      <a [href]="baseUrl" class="back-to-home">
        <i class="fa-solid fa-arrow-left"></i>
        <span>{{ 'signup.go-to-home' | translate }}</span>
      </a>
      <div class="account">
        <span>
          {{ 'signup.have-account' | translate }}
        </span>
        <a [routerLink]="'/auth/login'">
          {{ 'signup.sign-in' | translate }}
        </a>
      </div>
    </div>
    <form [formGroup]="SignupForm" (ngSubmit)="onSubmit()">
      <div class="form-card">
        <h3 class="title">
          {{ 'signup.sign-up' | translate }}
        </h3>
        <div class="input-group">
          <input type="email" class="form-control" formControlName="email" (blur)="trimField('email')" [placeholder]="'signup.email-placeholder' | translate" name="" id="">
          <span class="error text-danger" *ngIf="
                  SignupForm.controls['email'].invalid && SignupForm.controls['email'].touched
                ">
            <span *ngIf="SignupForm.controls['email'].errors?.['required']">
              {{ 'signup.email-required' | translate }}
            </span>
            <span *ngIf="SignupForm.controls['email'].errors?.['email']">
              {{ 'signup.email-invalid' | translate }}
            </span>
          </span>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="input-group">
              <input type="text" class="form-control" formControlName="fname" (blur)="trimField('fname')" [placeholder]="'signup.first-name' | translate" name="" id="">
              <span class="error text-danger" *ngIf="
                  SignupForm.controls['fname'].invalid && SignupForm.controls['fname'].touched
                ">
                <span *ngIf="SignupForm.controls['fname'].errors?.['required']">
                  {{ 'signup.first-name-required' | translate }}
                </span>
                <span *ngIf="SignupForm.controls['fname'].errors?.['minlength']">
                  {{ 'signup.first-name-min' | translate }}
                </span>
                <span *ngIf="SignupForm.controls['fname'].errors?.['pattern'] && !SignupForm.controls['fname'].errors?.['minlength']">
                  {{ 'signup.name-letters-only' | translate }}
                </span>
              </span>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group">
              <input type="text" class="form-control" formControlName="lname" (blur)="trimField('lname')" [placeholder]="'signup.last-name' | translate" name="" id="">
              <span class="error text-danger" *ngIf="
                  SignupForm.controls['lname'].invalid && SignupForm.controls['lname'].touched
                ">
                <span *ngIf="SignupForm.controls['lname'].errors?.['required']">
                  {{ 'signup.last-name-required' | translate }}
                </span>
                <span *ngIf="SignupForm.controls['lname'].errors?.['minlength']">
                  {{ 'signup.last-name-min' | translate }}
                </span>
                <span *ngIf="SignupForm.controls['lname'].errors?.['pattern'] && !SignupForm.controls['lname'].errors?.['minlength']">
                  {{ 'signup.name-letters-only' | translate }}
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="input-group position-relative country-dropdown2 ">
          <ngx-intl-tel-input *ngIf="selectedCountryISO" [cssClass]="'form-control'" [enableAutoCountrySelect]="false"
            [enablePlaceholder]="true" [searchCountryFlag]="true"
            [searchCountryField]="[SearchCountryField.Name, SearchCountryField.DialCode, SearchCountryField.Iso2]"
            [selectFirstCountry]="false" [selectedCountryISO]="selectedCountryISO" [separateDialCode]="true"
            [phoneValidation]="true" formControlName="phone_number">
          </ngx-intl-tel-input>
          <span class="error text-danger" *ngIf="
                  SignupForm.controls['phone_number'].invalid && SignupForm.controls['phone_number'].touched
                ">
            <span *ngIf="SignupForm.controls['phone_number'].errors?.['required']">
              {{ 'signup.phone-required' | translate }}
            </span>
            <span *ngIf="SignupForm.controls['phone_number'].errors?.['validatePhoneNumber']">
              {{ 'signup.phone-invalid' | translate }}
            </span>
          </span>
        </div>
        <!-- A registered identity cannot be changed here; a password is not needed to continue. -->
        <div class="input-group position-relative" *ngIf="!identityRegistered">
          <input [type]="isPasswordVisible ? 'text' : 'password'" id="password" class="form-control"
            formControlName="password" [placeholder]="'login.passwordPlaceholder' | translate" />

          <!-- Eye icon with preventDefault to avoid triggering touched -->
          <span (mousedown)="$event.preventDefault()" (click)="togglePasswordVisibility()" style="cursor: pointer;">
            <i [ngClass]="isPasswordVisible ? 'fa -solid fa-eye' : 'fa -solid fa-eye-slash'"></i>
          </span>

          <!-- ERROR BLOCK WITH FIXED HEIGHT (no layout shake) -->
          <div style="min-height: 20px; margin-top: 2px;">
            <span class="error text-danger"
              *ngIf="SignupForm.controls['password'].touched && SignupForm.controls['password'].invalid">
              <!-- Required error -->
              <span *ngIf="SignupForm.controls['password'].errors?.['required']">
                {{ 'signup.password-required' | translate }}
              </span>

              <!-- Invalid password - single message for all validation errors -->
              <span *ngIf="!SignupForm.controls['password'].errors?.['required'] &&
               SignupForm.controls['password'].invalid">
                {{ 'signup.password-min' | translate }}
              </span>
            </span>
          </div>
        </div>

        <div>
          <div class="custom-form-check mb-0">
            <input type="checkbox" formControlName="policy" id="flexCheckDefault" />
            <label for="flexCheckDefault">
              {{ 'signup.terms-prefix' | translate }}
              <a [href]="baseUrl + '/terms-conditions'" target="_blank">{{ 'signup.terms-of-use' | translate }}</a>
              {{ 'signup.and' | translate }}
              <a [href]="baseUrl + '/privacy-policy'" target="_blank">{{ 'signup.privacy-policy' | translate }}</a>.
            </label>
          </div>

          <div class="invalid-feedback d-block"
            *ngIf="SignupForm.controls['policy'].invalid && SignupForm.controls['policy'].touched">
            <span class="error text-danger">
              {{ 'signup.terms-required' | translate }}
            </span>
          </div>
        </div>

        <button type="submit" class="btn btn-primary btn-md w-100" [disabled]="isLoading()">{{ identityRegistered ? 'Continue' : ('signup.sign-up-btn' | translate) }}</button>
        <!-- <div class="or">
          <div class="line"></div>
          <span>Or</span>
        </div> -->
        <!-- <div class="other-login-options">
          <div class="row">
            <div class="col-md-6">
              <button class="btn btn-google">
                <img src="assets/images/google.svg" alt="">
                Sign up with Google
              </button>
            </div>
            <div class="col-md-6">
              <button class="btn btn-fb">
                <img src="assets/images/facebook.svg" alt="">
                Sign up with FB
              </button>
            </div>
          </div>
        </div> -->

      </div>
      <div class="form-card">
        <!-- <p class="recaptcha">
          Protected by reCAPTCHA and subject to the Prism
        </p> -->
      </div>
    </form>
    <div></div>
  </div>
</div>
<!-- Registaration -->